<template>
  <div>
    <label for="trackingNumber">Parcel Tracking Number</label>
    <input type="text" id="trackingNumber" @blur="handleBlur" v-model="trackingNumber">

    <p v-if="form_message" id="form-message-text" class="validation-error">{{form_message}}</p>

    <input type="button" id="btn-tracking" class="primary-button" v-on:click="retrieve" :disabled=isDisabled value="Retrieve Tracking Information">
    <div v-if="this.$store.state.businessAccount">
      <input type="button" class="baButtons" id="btn-van-collection-enquiry" v-on:click="handleButtonVanCollectionEnquiry" value="Van Collection Enquiry">
      <input type="button" class="baButtons" id="btn-order-next-day-labels" v-on:click="handleButtonOrderNextDayLabels" value="Order Next Day Labels">
      <input type="button" class="baButtons" id="btn-order-assets" v-on:click="handleButtonOrderAssets" value="Order Assets">
      <input type="button" class="baButtons" id="btn-priceband-enquiry" v-on:click="handleButtonPricebandEnquiry" value="Priceband Enquiry">
    </div>
    <input type="hidden" name="barcode" v-model="trackingNumberSaved">

    <div v-if="trackingResults.length > 1">
      <p>I found more than one parcel. Please select the barcode of the one you are interested in.</p>
      <select @input="selectTracking">
        <option selected value> -- Select a Barcode -- </option>
        <option v-for="(res, index) in trackingResults" :value="index">{{res.barcode}}</option>
      </select>
    </div>

    <div v-if="error" id="error-message" class="multiline">{{getErrorMessage()}}</div>

    <div v-if="trackingResults.length === 0" id="error-tracking-not-found">Did not find any tracking details</div>

    <TrackingInformation id="tracking-information" v-if="selectedTracking || getTrackingOverride()" :tracking="selectedTracking"/>

    <router-view v-if="selectedTracking || getTrackingOverride() || this.$store.state.businessAccount"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TrackingInformation from './TrackingInformation'
import TrackingApi from '../api/Tracking'

export default {
  data () {
    return {
      trackingNumber: '',
      trackingNumberSaved: '',
      trackingResults: false,
      error: false,
      loading: false,
      overrideTracking: false
    }
  },
  watch: {
    trackingResults() {
      if(this.trackingResults.length === 1) {
        this.$store.commit('selectTracking', this.trackingResults[0])
      }
    }
  },
  computed: {
    ...mapState({
      selectedTracking: state => state.tracking
    }),
    isDisabled() {
      return this.loading || this.trackingNumber.length === 0
    }
  },
  methods: {
    resetBA(text) {
      this.trackingResults = false
      this.error = false
      this.$store.state.overrideTracking = false;
      this.$store.commit('selectTracking', false)
      this.$router.push('/').catch(err => {})

      Array
        .from(document.getElementsByClassName('baButtons'))
        .filter(elem => elem.id != 'btn-' + text)
        .forEach(elem => elem.classList.remove('btnActive'));
    },
    handleBaButton(text) {
      this.resetBA(text);
      document.getElementById('btn-' + text).classList.add('btnActive');
      this.$router.push('/' + text).catch(err => {});
      this.$store.state.businessAccountSpecific = true;
    },
    handleButtonVanCollectionEnquiry () {
      this.handleBaButton('van-collection-enquiry');
    },
    handleButtonOrderNextDayLabels () {
      this.handleBaButton('order-next-day-labels');
    },
    handleButtonOrderAssets () {
      this.handleBaButton('order-assets');
    },
    handleButtonPricebandEnquiry () {
      this.handleBaButton('priceband-enquiry');
    },
    selectTracking(e) {
      const options = e.target.options;
      const selectedOption = options[e.target.selectedIndex];

      const selectedText = selectedOption.textContent;

      if (e.target.selectedIndex > 0) {
        this.trackingNumberSaved = selectedText;
        this.$store.state.trackingNumber = selectedText;
      } else {
        this.trackingNumberSaved = '';
        this.$store.state.trackingNumber = ''
      }

      this.$router.push('/').catch(err => {})
      this.$store.commit('selectTracking', e.target.value === '' ? false : this.trackingResults[e.target.value])
    },
    getErrorMessage() {
      if(this.getTrackingOverride()) {
        return `
Thank you for getting in touch with your enquiry via the webform. Our tracking system is not working as it should right now so to help us raise your request to the right team, please could you pick the most relevant options to describe your enquiry from the options below.

I can assure you all our teams are working closely together to fix this and as soon as tracking is updating correctly, the webform will resume to its normal operation.

Thank you for your patience.
`;
      }
      const status = this.error.response.status;
      if(500 <= status && status <= 599) {
        return 'Our tracking is unavailable at the moment, we are aware of the issue and are working on it urgently. We apologise for any inconvenience caused. Please know our teams are working hard to get everything up and running. Please try again later.';
      }
      const errors = this.error.response.data.errors || [];
      const message = errors.map(e => e.message).join(' ');
      return message || 'Failed to retrieve tracking information.';
    },
    retrieve() {
      this.reset();
      this.loading = true;
      this.form_message = '';
      if(!this.handleBarcodeValidation()) {
        this.loading = false;
        this.form_message = 'Please enter a valid tracking number.';
        return;
      }
      // Set the 'barcode' form value here in case user changes the field before submit
      this.trackingNumberSaved = trackingNumber.value.trim();
      // Store the barcode for use in the e-mail subject field
      this.$store.state.trackingNumber = this.trackingNumberSaved;
      Array.from(document.getElementsByClassName('baButtons')).forEach(elem => elem.classList.remove('btnActive'));
      this.$store.state.businessAccountSpecific = false;

      TrackingApi
        .getTracking(this.trackingNumber)
        .then((response) => {
          this.trackingResults = response.data;
          if(this.trackingResults.length === 1 && this.trackingNumber.charAt(0).toUpperCase() === "P") {
            // use the barcode from the response not the P number if there is only 1 parcel associated
            this.trackingNumberSaved = this.trackingResults[0].barcode;
            this.$store.state.trackingNumber = this.trackingNumberSaved;
          }
        })
        .catch(error => {
          this.error = error;
          if(this.error.response.data.errors.find(e => e.message != "The tracking number provided is invalid.") != undefined) {
            this.setTrackingOverride();
          }
        })
        .finally(() => {this.loading = false});
    },
    reset() {
      this.trackingResults = false
      this.error = false
      this.$store.state.overrideTracking = false;
      this.$store.commit('selectTracking', false)
      this.$router.push('/').catch(err => {})
    },
    setTrackingOverride() {
      if(this.$store.state.override) {
        this.$store.state.overrideTracking = true;
      }
    },
    getTrackingOverride() {
      return this.$store.state.overrideTracking;
    },
    handleBarcodeValidation() {
      // Front end validation for tracking number
      const numeric_regex = /^[0-9]{16}$/;
      const strategic_regex = /^[HCT][A-Z0-9]{4}[A-E][0-9]{10}$/;
      const pnumber_regex = /^P[0-9]{7,8}$/;
      if(!trackingNumber.value.trim().match(numeric_regex) &&
      !trackingNumber.value.trim().match(strategic_regex) &&
      !trackingNumber.value.trim().match(pnumber_regex)) {
        return false;
      }
      return true;
    },
    handleBlur(e) {
      var val = e.target.value;
      val = val.trim().replace("#", "");
      this.trackingNumber = val;
    }
  },
  components: {
    TrackingInformation
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TrackingSearch.vue